// apps/web/src/pages/TrendsTab.tsx
//
// Thin wrapper that exposes the existing StoriesAnalyticsPage as a
// tab-pane component. Introduced in Task 1 of the P8a plan so the
// AnalyticsPageShell can declare a single `<TrendsTab>` slot.
//
// The body is intentionally a single render call — all chart logic
// remains in StoriesAnalyticsPage.

import { StoriesAnalyticsPage } from './StoriesAnalyticsPage'
import type { TimeRange } from '@/types/story'

export interface TrendsTabProps {
  range: TimeRange
  setRange: (r: TimeRange) => void
}

export function TrendsTab({ range, setRange }: TrendsTabProps) {
  return <StoriesAnalyticsPage range={range} setRange={setRange} />
}
